import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level15Illustration({
  achievementId,
  variant = 'cosmic',
  // Unlocks cosmic variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3744">
      <div className="relative w-full h-full bg-gradient-to-br from-slate-900 via-indigo-950 to-purple-950 overflow-hidden" data-id="element-3745">
        {/* Background: Space, Nebula, Planets */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3746">
          {/* Nebula clouds */}
          <circle cx="40" cy="40" r="60" fill="#8B5CF6" opacity="0.2" filter="blur(15px)" data-id="element-3747" />
          <circle cx="160" cy="160" r="70" fill="#3B82F6" opacity="0.2" filter="blur(20px)" data-id="element-3748" />
          <circle cx="150" cy="50" r="50" fill="#EC4899" opacity="0.15" filter="blur(15px)" data-id="element-3749" />

          {/* Planet */}
          <circle cx="160" cy="40" r="20" fill="#FDE047" opacity="0.8" data-id="element-3750" />
          <path d="M130 50 Q160 30 190 50" stroke="#FEF08A" strokeWidth="4" strokeLinecap="round" fill="none" transform="rotate(-15 160 40)" data-id="element-3751" />

          {/* Distant stars */}
          <circle cx="30" cy="80" r="1" fill="white" data-id="element-3752" />
          <circle cx="80" cy="30" r="1.5" fill="white" data-id="element-3753" />
          <circle cx="120" cy="120" r="1" fill="white" data-id="element-3754" />
          <circle cx="50" cy="150" r="2" fill="white" data-id="element-3755" />
          <circle cx="180" cy="100" r="1.5" fill="white" data-id="element-3756" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3757">
          <div className="w-[65%] h-[65%] flex items-center justify-center animate-[bounce_4s_ease-in-out_infinite]" data-id="element-3758">
            <DjaySpecimen look={{
            variant,
            accessory: 'cosmicOrb'
          }} size="hero" emotion={isUnlocked ? 'proud' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3759" />
          </div>
        </div>

        {/* Foreground: Floating Asteroids and Magic */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3760">
            {/* Asteroids */}
            <path d="M20 120 L25 115 L35 118 L30 125 Z" fill="#64748B" data-id="element-3761" />
            <path d="M170 140 L180 135 L185 145 L175 150 Z" fill="#475569" data-id="element-3762" />
            <path d="M40 40 L45 35 L50 42 L42 45 Z" fill="#94A3B8" data-id="element-3763" />

            {/* Sparkles */}
            <path d="M140 80 L142 85 L147 87 L142 89 L140 94 L138 89 L133 87 L138 85 Z" fill="#A78BFA" data-id="element-3764" />
            <path d="M60 160 L61 163 L64 164 L61 165 L60 168 L59 165 L56 164 L59 163 Z" fill="#60A5FA" data-id="element-3765" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}